import { ElMessageBox } from 'element-plus'

/**
 * 로그아웃 — 확인을 받고 세션을 끊은 뒤 로그인 화면을 **새로 불러온다**.
 *
 * 상단바(모바일) · 좌측 레일(데스크톱) · 더보기 세 곳이 같은 코드를 한 벌씩 들고 있었다.
 * router.push('/login') 로 끝내면 스토어 · 모듈 단위 캐시(업무 · 영업 · 알림 목록 · 인사 기록)가
 * 메모리에 그대로 남아, 같은 기기에서 다음 사람이 로그인하면 앞 사람의 목록이 잠깐 보인다.
 * 페이지를 새로 여는 것이 그 전부를 한 번에 비우는 유일하게 확실한 방법이다.
 */
export async function confirmLogout(store) {
  try {
    await ElMessageBox.confirm('로그아웃하시겠습니까?', '로그아웃', {
      confirmButtonText: '확인',
      cancelButtonText: '취소',
      type: 'warning'
    })
  } catch {
    return // 취소
  }
  await store.dispatch('logout') // 실패해도 클라이언트 상태는 비운다(store/modules/auth.js)
  window.location.replace('/login')
}
